angular.module( 'acme.view.application.resources.staff', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.staff.assign',
  'acme.view.application.resources.staff.controllers',
  'acme.view.application.resources.staff.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesStaff = {
        name: 'application.resources.staff',
        url: '/staff',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'ResourcesStaffController',
            templateUrl: 'views/application/views/resources/staff/staff.tpl.html'
          }
        }
      },
      resourcesStaffList = {
        name: 'application.resources.staff.list',
        url: '',
        views: {
          "subview-main": {
            controller: 'ResourcesStaffListController',
            templateUrl: 'views/application/views/resources/staff/staffList.tpl.html'
          }
        },
        data: {
          pageTitle: 'Personnel Manager',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.facilities.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(resourcesStaff)
      .state(resourcesStaffList);
});
